import { AxiosResponse } from 'axios';
import AxiosInstanceYalo from './AxiosInstanceYalo';
import { TemplateInfo } from './types';

export const getVerifiedTemplateFullInfo = async (id: string): Promise<AxiosResponse<TemplateInfo>> =>
  AxiosInstanceYalo.get(`v1/template/${id}?full=true`);
